// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCaretUpOutlinedSvg from "@fishx/icons-svg/es/asn/PCaretUpOutlined";
import FishxIcon from '../components/FishxIcon';

var PCaretUpOutlined = function PCaretUpOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCaretUpOutlinedSvg
  }));
};

PCaretUpOutlined.displayName = 'PCaretUpOutlined';
export default React.forwardRef(PCaretUpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCaretUpOutlined.js
// module id = 3269
// module chunks = 0